import './../css/speaker-cv.css'
import parse from 'html-react-parser';
import React from 'react'

const ReferentCV = ({ referent }) => {
    return (
        <div className="speaker-cv-container">

            <div className="photo-address-container">

                <img className="speaker-foto-cv" src={`${process.env.PUBLIC_URL}/assets/images/${referent.Foto}`} alt={`${referent.Vorname} ${referent.Nachname}`} />

                <div>
                    <div>{referent.Titel}</div>

                    <div><strong>{referent.Vorname} {referent.Nachname}</strong></div><br />

                    <div className="cv-text">{referent.Allgemein ? parse(referent.Allgemein) : ""}</div>
                </div>

            </div>

            {(referent.Interessenskonflikte) ?
                <div className="interessenskonflikte-container">
                    <b>Offenlegung möglicher Interessenskonflikte:</b> <br />
                    {parse(referent.Interessenskonflikte)}
                </div>
                : ""}
        </div>
    )
}

export default ReferentCV